export const parseSolutionsOurExpertiseContent = (page) => {
  if (!page?.sections?.length) {
    return null;
  }

  const section = page.sections.find((item) => item.key === 'our-expertise');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};

  if (!fields.title) {
    return null;
  }

  const cards = [];

  for (let index = 1; index <= 20; index += 1) {
    const category = fields[`card-${index}-category`];
    if (!category) {
      break;
    }

    cards.push({
      category,
      title: fields[`card-${index}-title`] || '',
      cardDescription: fields[`card-${index}-description`] || '',
      cta: fields[`card-${index}-cta`] || '',
      slug: fields[`card-${index}-url`] || '#',
    });
  }

  if (cards.length === 0) {
    return null;
  }

  return {
    title: fields.title,
    cards,
  };
};
